import { render, staticRenderFns } from "./dingdan.vue?vue&type=template&id=41350844&"
import script from "./dingdan.vue?vue&type=script&lang=js&"
export * from "./dingdan.vue?vue&type=script&lang=js&"
import style0 from "./dingdan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports